module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Kuettigen_AG-5de78d07c384ba966e30be5acac119ef.svg";